import BybVrSwitch from "@Components/game/common/dialog/byb-vr-switch";
import { GameModeCard } from "@Components/game/game-mode";
import { usePractiseContext } from "@Context/game/practise/practise-context";
import { AnalyticsEvents } from "@Enums/index";
import PlayModes from "@Enums/PlayModes";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
const AwarenessTestsConfig = () => {
  const { i18n } = useI18n();
  const { sessionOptions, setSessionOptions, selectedDivision } = usePractiseContext();
  const [isAvailable, setIsAvailable] = useState<boolean | undefined>(true);
  const { track } = useAnalytics();

  const handleAwarenessTestsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSessionOptions({
      ...sessionOptions,
      awareness_tests: event.target.checked,
    });
    track(AnalyticsEvents.practice_settings_adjusted, { awareness_tests: event.target.checked });
  };

  useEffect(() => {
    setIsAvailable(
      selectedDivision?.play_item_config?.playable_modes?.find((item: any) => {
        return item.mode === PlayModes.AWARENESS;
      })
    );
  }, [selectedDivision?.play_item_config]);

  return (
    <GameModeCard>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="text1xl500" color="dsNeutral.v300">
          {i18n("practice.awareness.tests")}
          {!isAvailable ? ` - (${i18n("not-available")})` : ""}
        </Typography>
        <BybVrSwitch
          disabled={!isAvailable}
          checked={!isAvailable ? false : sessionOptions.awareness_tests || false}
          onChange={handleAwarenessTestsChange}
        />
      </Stack>
    </GameModeCard>
  );
};

export default AwarenessTestsConfig;
